<!-- scroll-behavior and scroll-snap-type must be inline, to ensure the polyfill kicks in when not supported -->
<div
    class="content"
    [ngClass]="{ 'text-center': centerAlign }"
    [ngStyle]="style"
    style="scroll-behavior: smooth; scroll-snap-type: x mandatory"
    #content
>
    <ng-content></ng-content>
</div>
